import { ReachAPI } from './ReachAPI';
import { Log } from '../AuxillaryService/Log';

/**
 * @class quotes
 * @hideconstructor
 * @memberof ReachAPI
 */
ReachAPI.quotes = {};

/**
 * GET Endpoint `/quotes/`
 * @param {string} quoteType
 * @param {number} numberOfQuotes
 * @param {ReachAPI.Security} security
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.quotes
 */
ReachAPI.quotes.getQuotesForType = function (quoteType, numberOfQuotes, security) {
    var cache_id = '/quotes/quoteType=' + quoteType;
    var url = ReachAPI.server + '/quotes';
    var params = {
        type: quoteType,
        count: numberOfQuotes,
    };
    var jqPromise;

    // add security data
    params = security.merge(params);

    jqPromise = ReachAPI.getWithFallback(url, 'json', params, cache_id);

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Info('Retrieved Quotes from the CACHE (API call failed)', null, __fileline);
        } else {
            Log.Info('Retrieved Quotes from the API', null, __fileline);
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve Quotes',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};
